import { IQueryMediator, IQuery } from 'core-ts-types';
import { ITransferGradesDatasource } from '../datasources/transfer_grades_datasource';
import * as _4 from 'lodash4';
import { Grade } from '../builders/grade_builder';

export class TransferGradeQuery implements IQuery {
  private _result: Grade[];
  constructor(QueryMediator: IQueryMediator, private ngTransferGradesDatasource: ITransferGradesDatasource) {
    QueryMediator.registerQuery(this, ngTransferGradesDatasource);
  }

  run(): TransferGradeQuery {
    this._result = _4.orderBy(this.ngTransferGradesDatasource.read(), ['grade_points'], ['desc']);
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-transfer').service('ngTransferGradeQuery', TransferGradeQuery);



// WEBPACK FOOTER //
// ./app/lib/transfer/queries/transfer_grade_query.ts